import { useState } from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import useApi from '../../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import { TextareaField } from '../../../../../utils/InputField';
import { useInvoiceInfo } from '../InvoiceInfoProvider';

function ModalUpdateInvoiceTitle() {
    const { handleReload, invoiceInfo } = useInvoiceInfo();
    const { put } = useApi();
    const { setMessage, closeModal } = useTemplate();
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const data = invoiceInfo?.invoice || {};
    const [formData, setFormData] = useState({
        InvoiceId: data?.id,
        Title: data?.title || ''
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name) {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSaveClick = (e) => {
        e?.preventDefault();
        setLoading(true);
        put(`api/invoices/${data?.id}/update-title`, formData)
            .then(({ error, message, referenceName }) => {
                if (error) {
                    setIsError(referenceName);
                    throw new Error(message);
                }
                closeModal();
                handleReload();
                setMessage({ type: 'success', text: message });
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err?.message });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleSaveClick}>
            <div className="flex flex-col gap-y-3 mb-5">
                <TextareaField
                    label="Title"
                    name="Title"
                    placeholder="Type Title..."
                    formData={formData}
                    onChange={handleChange}
                    className="h-36"
                    required
                />
            </div>

            <div className="flex justify-end">
                <div className="flex items-center gap-x-3">
                    <ButtonCancel title="Cancel" onClick={closeModal} />
                    <ButtonPrimary title="Update" btnType="submit" loading={loading} />
                </div>
            </div>
        </form>
    );
}

export default ModalUpdateInvoiceTitle;
